import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Intro from '../components/home/intro';
import First from '../components/home/first';
import Interactivo from '../components/home/interactivo';
import Category from '../components/home/category';
import Presentation from '../components/home/presentation';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Scrollspy from 'react-scrollspy'

export default class IndexWithoutInteractivo extends React.Component{
  state = {
    bg: '#5005f2',
    active: 'intro',
    results: false,
    showPresentation: true
  }

  componentDidMount(){

  }

  setCurrentSection(element){
    if(element){
      var id = element.getAttribute('id');
    }else{
      var id= false;
    }
    if(id){
      var color = '#4818c4';

      var dark = ['intro', 'interactivo'];

      switch(id){
        case "first":
          color = '#fbc402'
        break;
        case "interactivo":
          color = '#111';
        break;
        case "iresumen":
          color = '#111';
        break;
      }

      this.setState({
        // bg: color,
        active: id
      })

      // document.body.classList.remove('is-dark');
      // if(dark.indexOf(id) > -1){
      //   document.body.classList.add('is-dark');
      // }
    }
  }

  render(){
    return(
      <div id="home" style={{backgroundColor: this.state.bg}}>
        <div className="home_logo mobile_noshow">
          <a href="https://animalpolitico.com" target="_blank">
            <img src={require('../static/ap.png')}/>
          </a>
        </div>
          <div id="icontent">
            <div id="icontent_container">
            <Element name="interactivo">
              <Interactivo active={this.state.active} onFetch={(results) => this.setState({results: results})}/>
            </Element>
            </div>
          </div>
          {
            this.state.results ?
            <>
            <Category
              label={'familiar'}
              or={this.state.results}
              r={this.state.results.p['familiar']}
              logo={require('../static/cat_1.png')}
              cover={require('../static/cat_cover_1.png')}
              bgs={['#d30d81', '#ea7b63']}
              colors={{
                highlight: [
                  'rgba(240, 240, 240, 0.83)',
                  'rgba(240, 240, 240, 0.65)'
                ],
                normal: [
                  'rgba(110, 110, 110, 0.5)',
                  'rgba(110, 110, 110, 0.1)'
                ],
                clear: '#f0f0f0',
                dark: '#333'
              }}
            />
            <Category
              label={'laboral'}
              isDark
              or={this.state.results}
              r={this.state.results.p['laboral']}
              logo={require('../static/cat_2.png')}
              cover={require('../static/cat_cover_2.png')}
              bgs={['#e7c12d', '#f1f312']}
              colors={{
                highlight: [
                  'rgba(196, 26, 73, 0.87)',
                  'rgba(196, 26, 73, 0.83)'
                ],
                normal: [
                  'rgba(110, 110, 110, 0.5)',
                  'rgba(110, 110, 110, 0.1)'
                ],
                dark: '#666',
                clear: '#333'
              }}
            />
            <Category
              label={'cívico'}
              or={this.state.results}
              r={this.state.results.p['civico']}
              logo={require('../static/cat_3.png')}
              cover={require('../static/cat_cover_3.png')}
              bgs={['#440bee', '#06f4aa']}
              colors={{
                highlight: [
                  'rgba(252, 1, 71, 1)',
                  'rgba(128, 81, 241, 1)'
                ],
                normal: [
                  'rgba(240, 1, 67, 0.5)',
                  'rgba(240, 1, 67, 0.1)'
                ],
                clear: '#f0f0f0',
                dark: '#666'
              }}
            />
            <Category
              isDark
              label={'de consumidor'}
              or={this.state.results}
              r={this.state.results.p['consumidor']}
              logo={require('../static/cat_4.png')}
              cover={require('../static/cat_cover_4.png')}
              bgs={['#06cb59', '#d7f305']}
              colors={{
                highlight: [
                  'rgba(252, 1, 71, 1)',
                  'rgba(128, 81, 241, 1)'
                ],
                normal: [
                  'rgba(240, 1, 67, 0.5)',
                  'rgba(240, 1, 67, 0.1)'
                ],
                dark: '#666',
                clear: '#333'
              }}
            />
            </>
          : null
          }
          <Scrollspy
            offset={-150}
            style={{display: 'none'}}
            items={ ['intro', 'first', 'interactivo', 'iresumen'] }
            currentClassName="is-current"
            onUpdate={(e) => this.setCurrentSection(e)}
          >
          </Scrollspy>
      </div>
    )
  }
}
